import {
  BILLING_PLANS,
  BILLING_PLANS_BY_PRICE_ID,
  type BillingPlanCode,
  type BillingPlanDefinition
} from '~config/stripe-plans';

export interface StripeProduct {
  planCode: BillingPlanCode;
  name: string;
  description: string;
  priceId: string;
  price: number;
  interval: 'month' | 'year' | null;
  mode: 'subscription' | 'payment';
  features: string[];
  highlight?: string;
}

export const STRIPE_PRODUCTS: StripeProduct[] = Object.values(BILLING_PLANS).map(
  (plan: BillingPlanDefinition) => ({
    planCode: plan.id,
    name: plan.name,
    description: plan.description,
    priceId: plan.priceId,
    price: plan.amountUsd,
    interval: plan.interval,
    mode: plan.mode,
    features: plan.features,
    highlight: plan.highlight
  })
);

export { BILLING_PLANS, BILLING_PLANS_BY_PRICE_ID };
export type { BillingPlanCode, BillingPlanDefinition };
